export default () => {
  return window._env_.REACT_APP_API;
};

export const getSpaceUrl = () => {
  return window._env_.REACT_APP_S3_URL;
};